import { StatusColor } from '@enums/status-color.enum';
import { LegalFormalityAccountsApprovalEnum } from '@legal/legal-core/enums/legal-formality-accounts-approval.enum';

export const LEGAL_ACCOUNTS_APPROVAL_STATUS_COLOR: Record<LegalFormalityAccountsApprovalEnum, StatusColor> = {
  [LegalFormalityAccountsApprovalEnum.initialized]: StatusColor.grey3,
  [LegalFormalityAccountsApprovalEnum.notApplicable]: StatusColor.grey3,
  [LegalFormalityAccountsApprovalEnum.collectScopeToDo]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.collectAwaitingBalanceSheetClosure]: StatusColor.orange,
  [LegalFormalityAccountsApprovalEnum.collectAssignmentToDo]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.pvDocumentToGenerate]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.pvDocumentToCheck]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.pvMailToSend]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.pvSignatureToSend]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.pvAwaitingSignature]: StatusColor.orange,
  [LegalFormalityAccountsApprovalEnum.pvSignatureRefusal]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.depositToDo]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.depositToSign]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.depositToPay]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.depositAwaitingValidation]: StatusColor.orange,
  [LegalFormalityAccountsApprovalEnum.depositToRegularize]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.depositRejected]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.depositError]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.dossierToClose]: StatusColor.warn,
  [LegalFormalityAccountsApprovalEnum.completed]: StatusColor.accent
};
